import { combineReducers, compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { logger, crashReporter } from "../../../store";
import rootSaga from "../sagas";

import {
    subsidiariesList,
    subsidiariesLoading,
    subsidiaryEditing
} from "../reducers/subsidiaries.reducer";

const subsidiariesReducer = combineReducers({
    subsidiariesList,
    subsidiariesLoading,
    subsidiaryEditing
});

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Subsidiaries Store"
      })
    : compose;

const sagaMiddleware = createSagaMiddleware();

export const subsidiariesStore = createStore(
    subsidiariesReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const subsidiariesStoreSelectors = {
    subsidiariesList: (state = subsidiariesStore.getState()) =>
        state.subsidiariesList,
    subsidiariesLoading: (state = subsidiariesStore.getState()) =>
        state.subsidiariesLoading,
    subsidiaryEditing: (state = subsidiariesStore.getState()) =>
        state.subsidiaryEditing
};

sagaMiddleware.run(rootSaga);
